$(document).ready(function(){

	fadeScroll();

});



$(window).on('scroll resize orientationchange', function(){

	fadeScroll();

});


function fadeScroll(){
	$('.fadeScroll').each(function(i){
	  var top_of_object = $(this).offset().top;
	  var bottom_of_window = $(window).scrollTop() + $(window).height();
	  if(bottom_of_window > top_of_object){
	    $(this).animate({
	    	'opacity':'1',
	    	'top': 0
	    },800);
	  }
	});
}